export default function iterateSetProp(
  obj: any,
  propName: string,
  valuesObj: Record<string, any>,
  checkProto = false,
) {
  if (checkProto && !Object.prototype.hasOwnProperty.call(obj, propName))
    return;
  Object.keys(valuesObj).forEach((key) => {
    // eslint-disable-next-line no-param-reassign
    obj[propName][key] = valuesObj[key];
  });
}
